import {api} from 'api/setup';
import {
  ICustomerAddToFavoritesRequest,
  ICustomerAddToFavoritesResponse,
  ICustomerMyFavoritesResponse,
  ICustomerRemoveFromFavoritesRequest,
  ICustomerRemoveFromFavoritesResponse,
  ICustomerResponse,
  ICustomerUpdateRequest,
  ICustomerUpdateResponse,
} from 'types';

export const getCustomer = (): Promise<ICustomerResponse> => {
  return api.get('/customer');
};

export const getCustomerMyFavorites = (): Promise<ICustomerMyFavoritesResponse[]> => {
  return api.get('/customer-favourites/my-favorites');
};

export const updateCustomer = (data: ICustomerUpdateRequest): Promise<ICustomerUpdateResponse> => {
  return api.post('/customer/update', data);
};

export const customerAddToFavorites = ({
  data,
  slug,
}: ICustomerAddToFavoritesRequest): Promise<ICustomerAddToFavoritesResponse> => {
  return api.post(`/customer-favourites/${slug}/add`, {
    data,
    slug,
  });
};

export const customerRemoveFromFavorites = ({
  slug,
  data,
}: ICustomerRemoveFromFavoritesRequest): Promise<ICustomerRemoveFromFavoritesResponse> => {
  return api.post(`/customer-favourites/${slug}/remove`, {
    data,
    slug,
  });
};
